var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRibbonClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account-Dashboard---Personal-Loans",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal-Loans",
    transform: "translate(-687.000000, -402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pl_lfs-03",
    transform: "translate(408.000000, 402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ribbon_closed",
    transform: "translate(279.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E02020",
    points: "76 44.8873016 76 76 0 5.68434189e-14 31.1126984 5.68434189e-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.13162821e-14,2.84217094e-14 L5,5 L-2.13162821e-14,5 L-2.13162821e-14,8.52651283e-14 Z",
    id: "Combined-Shape",
    fill: "#860000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,71 L76,76 L71,76 L71,71 Z",
    id: "Combined-Shape",
    fill: "#860000"
  }), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED",
    transform: "translate(45.334524, 35) rotate(45.000000) translate(-45.334524, -35)",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    "line-spacing": 22,
    letterSpacing: -0.072,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 35
  }, "CLOSED"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRibbonClosed);
export default __webpack_public_path__ + "static/media/icon-ribbon-closed.503d31d3.svg";
export { ForwardRef as ReactComponent };